import React, { useState } from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    CardFooter,
} from "reactstrap";
import moment from 'moment';
// reactstrap components
import { useQuery } from 'react-query';
import { getDeviceParameter } from "API";
import SuspenseComponentText from '../../../views/components/SuspenseComponentText';

const staticParamTitles = {
    technical_break: "Technical Break",
    buy_rent: "Buy&Rent",
    swap: "Swap",
    return: "Return",
    columns_max_capacity: "Columns Max Capacity",
    price: "Price",
    price_rent: "Price Rent",
    deposit_value: "Deposit Value",
    column_critical_value: "Column Critical Value",
    terminal_serial: "Terminal Serial",
    client: "Client",
    fontColor: "fontColor",
    fontSecondaryColor: "fontSecondaryColor",
    fontTertiaryColor: "fontTertiaryColor",
    backgroundColor: "backgroundColor",
    buttonBackgroundColor: "buttonBackgroundColor",
    buttonFontColor: "buttonFontColor",
    support_phone_number: "Support Phone Number",
}

const COLUMN_PARAM_RE = /^column(\d+)(_status|_quantity)?$/;

const getParamTitle = (nameParam) => {
    const match = nameParam?.match(COLUMN_PARAM_RE);
    if (match) {
        const [, index, suffix] = match;
        if (suffix === '_status') return `Column ${index} Status`;
        if (suffix === '_quantity') return `Column ${index} Quantity`;
        return `Column ${index} Status & Quantity`;
    }
    return staticParamTitles[nameParam] ?? nameParam;
}


const DeviceDetailsParameterColumn = ({ serial, nameParam, elSize, elColor }) => {
    const [dataParameterStatus, setDataParameterStatus] = useState(null);
    const [dataParameterQuantity, setDataParameterQuantity] = useState(null);
    const [dataParameterCriticalValue, setDataParameterCriticalValue] = useState(null);
    const dataGetParameterStatus = useQuery(`${nameParam}_status`, () => getDeviceParameter(serial, `${nameParam}_status`), {
        refetchInterval: 60000,
        onSuccess: (data) => {
            setDataParameterStatus(data.data.value);
        }
    });
    const dataGetParameterQuantity = useQuery(`${nameParam}_quantity`, () => getDeviceParameter(serial, `${nameParam}_quantity`), {
        refetchInterval: 60000,
        onSuccess: (data) => {
            setDataParameterQuantity(data.data.value);
        }
    });
    const dataGetParameterCriticalValue = useQuery(`column_critical_value`, () => getDeviceParameter(serial, `column_critical_value`), {
        refetchInterval: 60000,
        onSuccess: (data) => {
            setDataParameterCriticalValue(data.data.value);
        }
    });

    const CriticalComponent = () => {
        return (
            <>
                {dataParameterQuantity === null || dataParameterCriticalValue === null ?
                    null : Number(dataParameterCriticalValue) >= Number(dataParameterQuantity) ?
                        <span className="label-has-danger label-ghost-effect"> Critical Value Reached</span> : null}
            </>


        )

    }

    const handleDataParameter = (parameterName, dataParameter) => {
        if (parameterName === 'technical_break') {
            return dataParameter === '0' ? 'Off' : 'On'
        }
        else if (parameterName === 'price' || parameterName === 'price_rent' || parameterName === 'deposit_value') {
            return `${dataParameter} £`
        }
        else if (/^column\d+_status$/.test(parameterName)) {
            return dataParameter === '0' ? <span className="label-has-danger">Inactive</span> : <span className="label-has-success">Active</span>
        }
        else if (/^column\d+_quantity$/.test(parameterName)) {
            return ` - ${dataParameter}`
        }
        else {
            return dataParameter
        }
    }


    return (
        <>
            <Col lg={elSize} md={elSize}>
                <Card className="card-stats">
                    <CardBody>
                        <Row>
                            <Col xs="3">
                                <div className={`info-icon text-center icon-${elColor}`}>
                                    <i className="tim-icons icon-components" />
                                </div>
                            </Col>
                            <Col xs="9">
                                <div className="numbers">
                                    <p className="card-category">{getParamTitle(nameParam)}</p>
                                    <CardTitle tag="h3">
                                        {dataGetParameterStatus.isLoading || dataGetParameterQuantity.isLoading ? <SuspenseComponentText /> :
                                            dataGetParameterStatus.isError || dataGetParameterQuantity.isError ? `Error` :
                                                (
                                                    <>
                                                        {handleDataParameter(`${nameParam}_status`, dataParameterStatus)}
                                                        {handleDataParameter(`${nameParam}_quantity`, dataParameterQuantity)}
                                                    </>
                                                )
                                        }

                                    </CardTitle>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <hr />
                        <div className="stats">
                            <i className="tim-icons icon-alert-circle-exc" />
                            {dataGetParameterStatus.isLoading ? <SuspenseComponentText /> :
                                dataGetParameterStatus.isError ? `Error` : <CriticalComponent />
                            }
                        </div>
                    </CardFooter>
                </Card>
            </Col>
        </>
    )
}

export default DeviceDetailsParameterColumn;